import React from 'react';
import { Save, FileText, Mail, RotateCcw } from 'lucide-react';
import { Button } from './ui/Button';
interface ActionsBarProps {
  onReset: () => void;
  onSave: () => void;
  onGeneratePDF: () => void;
  onEmail: () => void;
}
export function ActionsBar({
  onReset,
  onSave,
  onGeneratePDF,
  onEmail
}: ActionsBarProps) {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 p-4 shadow-lg z-10" data-id="element-1">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-2">
        <Button variant="ghost" onClick={onReset} className="text-slate-500 hover:text-slate-700" data-id="element-3">
          <RotateCcw className="mr-2 h-4 w-4" data-id="element-4" />
          Reset All
        </Button>

        <div className="flex items-center gap-3" data-id="element-5">
          <Button variant="outline" onClick={onEmail} data-id="element-6">
            <Mail className="mr-2 h-4 w-4" data-id="element-7" />
            Email Scenarios
          </Button>
          <Button variant="outline" onClick={onGeneratePDF} data-id="element-8">
            <FileText className="mr-2 h-4 w-4" data-id="element-9" />
            Generate PDF
          </Button>
          <Button onClick={onSave} className="bg-green-600 hover:bg-green-700 text-white" data-id="element-10">
            <Save className="mr-2 h-4 w-4" data-id="element-11" />
            Save to Opportunity
          </Button>
        </div>
      </div>
    </div>;
}